module.exports = __webpack_public_path__ + "img/lantern_right_1.a7ea1ac0.png";